import React, {useEffect, useState} from "react";
import {DatePicker, Select} from "antd";
import moment from "moment";

const {RangePicker} = DatePicker;
const {Option} = Select;

/**
 * @author Yaochao
 * @date 2021/7/12 14:58
 * @description search中select dateRange组件封装
 */
const ZkSelectDateRange = (props) => {
    const {
        defaultDay: defaultDay,
        showTime: showTime,
        title: title,
        valueKey: valueKey,
        setSearchParams: setSearchParams,
        setDefaultSearchParams: setDefaultSearchParams,
        resetKeys: resetKeys,
        style: style
    } = props;
    const [day, setDay] = useState(getDefaultDay());
    const [range, setRange] = useState(getDate(getDefaultDay()));

    useEffect(() => {
        if (resetKeys.indexOf(valueKey) != -1) {
            setDay(getDefaultDay());
            setRange(getDate(getDefaultDay()))
        }
    }, [resetKeys]);

    /**
     * 向group传递默认值
     */
    useEffect(() => {
        if (valueKey) {
            let range = getDate(getDefaultDay());
            setDefaultSearchParams(wraperData(getDefaultDay(), range));
        }
    }, []);

    function getDefaultDay() {
        if (defaultDay == null) {
            return -1;
        }
        return defaultDay;
    }

    function wraperData(day, dateRange) {
        let range = [];
        if (dateRange && dateRange.length == 2) {
            range[0] = dateRange[0].valueOf();
            range[1] = dateRange[1].valueOf();
        }
        return {
            [valueKey]: {
                'dateType': day,
                'dateRange': range
            }
        }
    }

    function dayChange(val) {
        setDay(val);
        let range = getDate(val);
        setRange(range);
        if (valueKey && val != 0) {
            if (range.length == 1) {
                setSearchParams(wraperData(val, range));
            } else if (range.length == 2) {
                setSearchParams(wraperData(val, range));
            }
        } else if (val == 0) {
            setSearchParams(wraperData(val));
        }
    }

    function dateRangeChange(date) {
        if (valueKey) {
            if (date && date.length == 2) {
                let val = [];
                if (showTime) {
                    let begin = date[0].valueOf();
                    let end = date[1].valueOf();
                    val.push(begin, end);
                } else {
                    let begin = moment(date[0].format('YYYY-MM-DD') + ' 00:00:00').valueOf();
                    let end = moment(date[1].format('YYYY-MM-DD') + ' 23:59:59').valueOf();
                    val.push(begin, end);
                }
                setSearchParams(wraperData(day, val));
                setRange(date);
            } else {
                setSearchParams(wraperData(day));
                setRange(date);
            }
        }
    }

    /**
     * 根据获取DatePicker的值
     */
    function getDate(day) {
        let range = [];
        if (day == -1) {
            //今天
            let now = new Date();
            let beginDate = moment(now).format('YYYY-MM-DD') + ' 00:00:00';
            let endDate = moment(now).format('YYYY-MM-DD') + ' 23:59:59';
            range.push(moment(beginDate));
            range.push(moment(endDate));
        } else if (day == -2) {
            //昨天
            let now = new Date();
            now.setDate(now.getDate() - 1);
            let beginDate = moment(now).format('YYYY-MM-DD') + ' 00:00:00';
            let endDate = moment(now).format('YYYY-MM-DD') + ' 23:59:59';
            range.push(moment(beginDate));
            range.push(moment(endDate));
        } else if (day > 0) {
            let now = new Date();
            range.push(moment(moment(now).format('YYYY-MM-DD') + ' 23:59:59'));
            now.setDate(now.getDate() - day + 1);
            range.unshift(moment(moment(now).format('YYYY-MM-DD') + ' 00:00:00'));
        }
        return range;
    }

    return (
        <li className='sg-item'>
            <label className='sg-item-title'>{title}</label>
            <div className='sg-item-wraper selectDateRange' style={{...style}}>
                <Select className='zk-selectdatepicker-slect' value={day} onChange={dayChange}
                        getPopupContainer={triggerNode => triggerNode.parentNode}>
                    <Option value={-1}>今天</Option>
                    <Option value={-2}>昨天</Option>
                    <Option value={7}>近7天</Option>
                    <Option value={30}>近30天</Option>
                    <Option value={0}>自定义</Option>
                </Select>
                {
                    day < 0 ? <DatePicker disabled={true} value={range[0]}/> :
                        <RangePicker disabled={day > 0}
                                     className={showTime ? 'zk-selectdatepicker-timerange' : 'zk-selectdatepicker-range'}
                                     value={range}
                                     getPopupContainer={triggerNode => triggerNode.parentNode}
                                     onChange={dateRangeChange} showTime={showTime}/>
                }
            </div>
        </li>
    )
};

export default ZkSelectDateRange;